import { IApplicationState } from '../../types/redux';

/**
 * Выбирает мету для статьей на Главной
 */
export const selectMainArticlesMeta = ({ mainArticles }: IApplicationState) => mainArticles.meta;
